import Glider from 'glider-js';

// Inint Glider
window.addEventListener('load', function () {
	document.querySelectorAll('.bookmakers-list .glider').forEach(function (elem) {
		new Glider(elem, {
			slidesToShow: 'auto',
			slidesToScroll: 'auto',
			itemWidth: 136,
			exactWidth: true,
			skipTrack: true,
			draggable: true,
			resizeLock: false,
			dragVelocity: 1,
			duration: 1,
			arrows: {
				prev: '.glider-prev',
				next: '.glider-next'
			}
		});
	});
});